module.exports = __webpack_public_path__ + "img/jamison-mcandie-waZEHLRP98s-unsplash.ccdcd224.jpg";